import { QueryClient } from "@tanstack/react-query";
import { shouldRetryMutation } from "@/lib/api/retry-policy";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: 3,
      retryDelay: 1000,
    },
    mutations: {
      /**
       * When a failed mutation may be resent: never a rejection the server
       * meant (a 4xx), never a POST, and an idempotent write once after a
       * server error or a dropped connection. Both earlier versions sent
       * validation rejections twice (autosave doubled every invalid IIN), and a
       * resent POST can duplicate a booking or a message. See retry-policy.ts.
       */
      retry: shouldRetryMutation,
    },
  },
});

// This code is only for TypeScript
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import("@tanstack/query-core").QueryClient;
  }
}

// This code is for all users - only run on client side
if (typeof window !== "undefined") {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient;
}
